<template>
  <component
    :is="'script'"
    src="https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js"
    async
    defer
  />
</template>
